import { ElectronicsWCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const ElectronicsWCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case ElectronicsWCActionType.ElectronicsWC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default ElectronicsWCReducer
